import { getSessionReadyFromSso } from '@discover-frontend/auth';

/**
 * Whether hx-accounts may call authenticated APIs (e.g. /users/me, /users/me/products).
 * False while Cognito refresh runs, session is locked, or access token is invalid.
 */
export const getAccountsSessionReady = (sso) => getSessionReadyFromSso(sso);
